export default {"src":"/_next/static/media/BRK.B.71d6b30e.svg","height":18,"width":18};